import { useEffect, useState } from "react";
import "./PaletteGenerator.css"
import Palette from "./Palette";
import { BACKEND_LINK } from "../../App";
import Toast from "./Toast";

function PaletteGenerator({hasPalette, hasPrompt, showLoginModal, onMenuToggle}) {
  const [colors, setColors] = useState([]);
  const [prompt, setprompt] = useState(null);
  const [toast, setToast] = useState(null);
  const [concreteness, setConcreteness] = useState(1);

  useEffect(() => {
    getFunc();
  }, []);

  function getFunc() {
    if(hasPalette)
      getPalette();
    if(hasPrompt)
      getPrompt();
  }

  function getPalette() {
    fetch(BACKEND_LINK + '/color')
      .then(response => response.json())
      .then(colors => setColors(colors));
  }
  
  function getPrompt() {
    fetch(BACKEND_LINK + `/prompt?concreteness=${concreteness}`)
      .then(response => response.text())
      .then(prompt => setprompt(prompt));
  }


  function savePalette() {
    fetch(BACKEND_LINK + "/color/save", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        {
          colors: colors.map(c => ({
            red: c.red ?? 0,
            green: c.green ?? 0,
            blue: c.blue ?? 0
          })),
          prompt: prompt
        }
      ),
      credentials: "include"
    }) .then((response) => {
    if (response.status === 403) {
      showLoginModal(); 
    } else if (response.status === 500) {
      setToast({ message: "Server error occurred", type: "error" });
    } else if (response.status === 507) {
      setToast({ message: "Palette limit reached (256). Please delete old ones.", type: "error" });
    } else if (response.ok) {
      setToast({ message: "Palette saved successfully!", type: "success" });
    }
    })
    .catch((error) => {
      setToast({ message: "Failed to save palette", type: "error" });
      console.error(error);
    });
    
  }

  return(
    <div className="palette-generator">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      <button className="menu-toggle" onClick={() => onMenuToggle?.()} aria-label="Toggle menu">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      {prompt != null ? 
        <div>
          <p id="prompt-intro">
            Your generated Idea is:
          </p>
          <p id="prompt">
            {prompt}
          </p>
        </div> : null}
      {
        colors.length > 0 ? 
          <p id="palette-intro">
            Color palette generated for this project:
          </p> : null
      }
      {colors.length > 0 ? 
        (
        <div>
          <Palette colors={colors}></Palette>
        </div>
        ) : null
      }
      <div className="button-container">
        <button onClick={savePalette}>I will paint this (save)</button>
        <button onClick={getFunc}>Regenerate</button>
      </div>
      {prompt != null ? (
        <div className="concreteness-slider">
          <label htmlFor="concreteness-level">Prompt concretness level</label>
          <p>Note that due to the procedural nature of generation, the more specific the prompt is, the more likely it is to be nonsensical.</p>
          <input
            id="concreteness-level"
            type="range"
            min="0"
            max="2"
            step="1"
            value={concreteness}
            onChange={(event) => setConcreteness(Number(event.target.value))}
          />
          <div className="concreteness-labels">
            <span>Vague</span>
            <span>Concrete</span>
            <span>Oddly specific</span>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default PaletteGenerator;